import { DefinitionSection } from "@logex/framework/lg-application";
import { IColumnFilterDictionary } from "@logex/framework/types";

export function idsToMultiFilter(
    ids: number[],
    definition: DefinitionSection
): IColumnFilterDictionary {
    const result: IColumnFilterDictionary = {};

    if (ids && ids.length) {
        ids.forEach(id => {
            result[id] = definition.data ? definition.data[id].name : "";
        });
    }

    return result;
}

export function multiFilterToCodes(multifilter: IColumnFilterDictionary): string[] {
    return multifilter && !multifilter.$empty ? Object.keys(multifilter) : [];
}

export function multiFilterToIds(multifilter: IColumnFilterDictionary): number[] {
    return multifilter && !multifilter.$empty ? Object.keys(multifilter).map(x => Number(x)) : [];
}

export function multiFilterToValues(multifilter: IColumnFilterDictionary): string[] {
    return multifilter && !multifilter.$empty ? Object.values(multifilter) : [];
}
